import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';


const routeAccess = {
  'live-tracking': ['ipl_super_admin', 'transporter', 'port_admin'],
  'user-management': ['ipl_super_admin', 'transporter', 'port_admin', 'field_officer'],
  'trip-management': ['ipl_super_admin', 'transporter', 'distributor', 'port_admin', 'retailer', 'region_head', 'field_officer'],
  'reports-analytics': ['ipl_super_admin', 'ipl_admin', 'port_admin'],
  'reports-secondary-trip': ['ipl_super_admin', 'ipl_admin', 'port_admin'],
  'reports-rake-movement': ['ipl_super_admin', 'ipl_admin', 'port_admin'],
  'ports-management': ['ipl_super_admin', 'port_admin'],
  'products-management': ['ipl_super_admin', 'port_admin'],
  'vehicles-management': ['ipl_super_admin', 'transporter', 'port_admin'],
  'dashboard': ['ipl_super_admin', 'transporter', 'port_admin'],
  'profile': ['ipl_super_admin', 'transporter', 'distributor', 'port_admin', 'retailer', 'account_officer', 'region_head', 'account_head', 'field_officer'],
  'correction-tickets': ['ipl_super_admin', 'ipl_admin', 'super_admin', 'superadmin', 'port_admin', 'account_officer'],
  'rake-receipts': ['ipl_super_admin', 'region_head', 'account_head', 'field_officer'],
  'missing-wagon-receipts': ['ipl_super_admin', 'ipl_admin', 'region_head', 'account_head', 'field_officer']
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }


  const pathname = location.pathname;
  const routeName = pathname === '/' || pathname === '/dashboard' ? 'dashboard' : pathname.substring(1);


  const userRole = userProfile?.role?.toLowerCase();


  if (routeAccess[routeName]) {
    if (!routeAccess[routeName].includes(userRole)) {
      if (userRole === 'distributor' || userRole === 'retailer') {
        return <Navigate to="/trip-management" replace />;
      } else if (userRole === 'transporter') {
        return <Navigate to="/live-tracking" replace />;
      } else if (['region_head', 'account_head', 'field_officer'].includes(userRole)) {
        return <Navigate to="/rake-receipts" replace />;
      } else if (userRole === 'account_officer') {
        return <Navigate to="/correction-tickets" replace />;
      } else {
        return <Navigate to="/dashboard" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;